import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'fl-display-card-image',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['./display-card-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayCardImageComponent {}
